import { saveToken, loadToken, deleteToken, loadUser, saveUser, deleteUser } from "./localStorage";

const auth = {
  authentication: false,
  isAuthenticated(callback) {
    if (loadToken() != null) {
      this.authentication = true;
      setTimeout(callback, 300);
    } else {
      this.authentication = false;
    }
    return this.authentication;
  },
  signout(callback) {
    deleteUser();
    deleteToken();
    this.authentication = false;
    setTimeout(callback, 300);
  },
  authenticate(token, user) {
    saveToken(token);
    saveUser(user)
  }
};

export default auth;
